import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";

import AdminLogin from "./Pages/AdminPages/AdminLogin/AdminLogin";
import Dashboard from "./Pages/AdminPages/Dashboard/Dashboard";
import AddAuthor from "./Pages/AdminPages/Author/AddAuthor/AddAuthor";
import EditAuthor from "./Pages/AdminPages/Author/EditAuthor/EditAuthor";
import DetailAuthor from "./Pages/AdminPages/Author/DetailAuthor/DetailAuthor";
import ViewAuthors from "./Pages/AdminPages/Author/ViewAuthor/ViewAuthors";
import AddBook from "./Pages/AdminPages/Books/AddBook/AddBook";
import ViewBooks from "./Pages/AdminPages/Books/ViewBooks/ViewBooks";
import EditBook from "./Pages/AdminPages/Books/EditBook/EditBook";
import DetailBook from "./Pages/AdminPages/Books/DetailBook/DetailBook";
import ViewUsers from "./Pages/AdminPages/Users/ViewUsers";
import ViewFeedback from "./Pages/AdminPages/Feedback/ViewFeedback";
import UnApprovedBooks from "./Pages/AdminPages/Books/UnApprovedBooks/UnApprovedBooks";
import ApprovedBooks from "./Pages/AdminPages/Books/ApprovedBooks/ApprovedBooks";
import Message from "./Pages/AdminPages/Message/Message";
import ViewMessages from "./Pages/AdminPages/Message/ViewMessages/ViewMessages";
import EditMessage from "./Pages/AdminPages/Message/EditMessage/EditMessage";
import AddBookCategory from "./Pages/AdminPages/BookCategory/AddBookCategory/AddBookCategory";
import ViewBookCategory from "./Pages/AdminPages/BookCategory/ViewBookCategory/ViewBookCategory";
import EditBookCategory from "./Pages/AdminPages/BookCategory/EditBookCategory/EditBookCategory";
import DetailBookCategory from "./Pages/AdminPages/BookCategory/DetailBookCategory/DetailBookCategory";
import Books from "./Pages/UserPages/Books/Books";
import UserDetailBook from "./Pages/UserPages/Books/Details/UserDetailBook";
import BookByGenre from "./Pages/UserPages/Books/BookBy/BookByGenre";
import GenreBookList from "./Pages/UserPages/Books/GenreBookList/GenreBookList";
import BookByAuthor from "./Pages/UserPages/Books/BookBy/BookByAuthor";
import AuthorBookList from "./Pages/UserPages/Books/AuthorBookList/AuthorBookList";
import SearchResults from "./Pages/UserPages/SearchResults/SearchResults";
import Home from "./Pages/UserPages/Home/Home";
import Login from "./Pages/UserPages/LoginSignUp/Login/Login";
import SignUp from "./Pages/UserPages/LoginSignUp/SignUp/SignUp";
import AboutUs from "./Pages/UserPages/AboutUs/AboutUs";
import FAQ from "./Pages/UserPages/FAQ/FAQ";
import FeedBack from "./Pages/UserPages/FeedBack/FeedBack";
import PreMailResetPassword from "./Pages/UserPages/ResetPassword/PreMailResetPassword/PreMailResetPassword";
import ResetPassword from "./Pages/UserPages/ResetPassword/ResetPassword";
import TermsAndCondition from "./Pages/UserPages/TermsAndCondition/TermsAndCondition";
import Cart from "./Pages/UserPages/Cart/Cart";
import BuyBook from "./Pages/UserPages/BuyBook/BuyBook";
import RentBook from "./Pages/UserPages/RentBook/RentBook";
import ReadBook from "./Pages/UserPages/Books/ReadBook/ReadBook";
import MyRentedBooks from "./Pages/UserPages/RentBook/MyRentedBooks/MyRentedBooks";
import PaymentHistory from "./Pages/UserPages/PaymentHistory/PaymentHistory";
import PaymentDetails from "./Pages/UserPages/PaymentHistory/PaymentDetails/PaymentDetails";
import PrePublishRules from "./Pages/UserPages/PublishBook/PrePublishRules";
import PublishBook from "./Pages/UserPages/PublishBook/PublishBook";
import AuthorMessage from "./Pages/UserPages/AuthorMessage/AuthorMessage";
import Profile from "./Pages/UserPages/Profile/Profile";
import EditProfile from "./Pages/UserPages/Profile/EditProfile";
import EditAuthorBooks from "./Pages/UserPages/MyBooks/AuthorMyBooks/EditAuthorBooks/EditAuthorBooks";
import MyBooks from "./Pages/UserPages/MyBooks/MyBooks";
import EmailConfirmation from "./Pages/UserPages/EmailConfirmation/EmailConfirmation";
import SuccessMessage from "./Pages/UserPages/SuccessMessage/SuccessMessage";
import AdminReadBook from "./Pages/AdminPages/Books/AdminReadBook/AdminReadBook";
import PageNotFound from "./Component/PageNotFound/PageNotFound";

const PrivateRoute = ({ isLogged, component: Comp, ...rest }) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        isLogged ? (
          <Comp {...props} />
        ) : (
          <Redirect to="/login/Customer" {...props} />
        )
      }
    />
  );
};

const PublicRoute = ({
  isAuthor,
  isLogged,
  restricted,
  component: Comp,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        restricted ? (
          isLogged || isAuthor ? (
            <Redirect to="/" {...props} />
          ) : (
            <Comp {...props} />
          )
        ) : (
          <Comp {...props} />
        )
      }
    />
  );
};

const AdminPublicRoute = ({
  isLogged,
  restricted,
  component: Comp,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        restricted ? (
          isLogged ? (
            <Redirect to="/_administration_/dashboard" {...props} />
          ) : (
            <Comp {...props} />
          )
        ) : (
          <Comp {...props} />
        )
      }
    />
  );
};

const AdminRoute = ({ isLogged, component: Comp, ...rest }) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        isLogged ? (
          <Comp {...props} />
        ) : (
          <Redirect to="/_administration_" {...props} />
        )
      }
    />
  );
};

class App extends Component {
  render() {
    return (
      <div id="main">
        <Switch>
          <AdminPublicRoute
            isLogged={this.props.isAdmin}
            restricted={true}
            path="/_administration_"
            exact
            component={AdminLogin}
          />

          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/book/read/:bookId"
            exact
            component={AdminReadBook}
          />

          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/dashboard"
            exact
            component={Dashboard}
          />

          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/author/add"
            exact
            component={AddAuthor}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/author/edit/:authorId"
            exact
            component={EditAuthor}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/author/detail/:authorId"
            exact
            component={DetailAuthor}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/author/view"
            exact
            component={ViewAuthors}
          />

          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/book/add"
            exact
            component={AddBook}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/book/view"
            exact
            component={ViewBooks}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/book/edit/:bookId"
            exact
            component={EditBook}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/book/detail/:bookId"
            exact
            component={DetailBook}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/books/unapproved"
            exact
            component={UnApprovedBooks}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/books/approved"
            exact
            component={ApprovedBooks}
          />

          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/user/view"
            exact
            component={ViewUsers}
          />

          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/feedback/view"
            exact
            component={ViewFeedback}
          />

          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/message/:bookId"
            exact
            component={Message}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/messages/view"
            exact
            component={ViewMessages}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/messages/edit/:messageId"
            exact
            component={EditMessage}
          />

          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/category/add"
            exact
            component={AddBookCategory}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/category/view"
            exact
            component={ViewBookCategory}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/category/edit/:categoryId"
            exact
            component={EditBookCategory}
          />
          <AdminRoute
            isLogged={this.props.isAdmin}
            path="/_administration_/category/detail/:categoryId"
            exact
            component={DetailBookCategory}
          />

          <PublicRoute
            isLogged={this.props.isAuth}
            isAuthor={this.props.isAuthor}
            restricted={this.props.isAuthor}
            path="/books"
            exact
            component={Books}
          />
          <PublicRoute
            isLogged={this.props.isAuth}
            isAuthor={this.props.isAuthor}
            restricted={this.props.isAuthor}
            path="/books/details/:bookId"
            exact
            component={UserDetailBook}
          />
          <PublicRoute
            isLogged={this.props.isAuth}
            isAuthor={this.props.isAuthor}
            restricted={this.props.isAuthor}
            path="/books/category/genre"
            exact
            component={BookByGenre}
          />
          <PublicRoute
            isLogged={this.props.isAuth}
            isAuthor={this.props.isAuthor}
            restricted={this.props.isAuthor}
            path="/books/category/genre/:genre"
            exact
            component={GenreBookList}
          />
          <PublicRoute
            isLogged={this.props.isAuth}
            isAuthor={this.props.isAuthor}
            restricted={this.props.isAuthor}
            path="/books/category/author"
            exact
            component={BookByAuthor}
          />
          <PublicRoute
            isLogged={this.props.isAuth}
            isAuthor={this.props.isAuthor}
            restricted={this.props.isAuthor}
            path="/books/category/author/:authorId"
            exact
            component={AuthorBookList}
          />

          <PublicRoute
            isLogged={this.props.isAuth}
            isAuthor={this.props.isAuthor}
            restricted={this.props.isAuthor}
            path="/search/query/:searchResult"
            exact
            component={SearchResults}
          />

          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={false}
            path="/"
            exact
            component={Home}
          />

          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={true}
            path="/login/:type"
            exact
            component={Login}
          />
          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={true}
            path="/signup/:type"
            exact
            component={SignUp}
          />

          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={false}
            path="/aboutus"
            exact
            component={AboutUs}
          />

          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={false}
            path="/faq"
            exact
            component={FAQ}
          />

          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={false}
            path="/feedback"
            exact
            component={FeedBack}
          />

          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={true}
            path="/password/recover/:type"
            exact
            component={PreMailResetPassword}
          />
          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={true}
            path="/password/reset/:type/:id/:token"
            exact
            component={ResetPassword}
          />

          <PublicRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            restricted={false}
            path="/termsandcondition"
            exact
            component={TermsAndCondition}
          />

          <PrivateRoute
            isLogged={this.props.isAuth}
            path="/cart"
            exact
            component={Cart}
          />

          <PrivateRoute
            isLogged={this.props.isAuth}
            path="/book/buy/:bookId"
            exact
            component={BuyBook}
          />

          <PrivateRoute
            isLogged={this.props.isAuth}
            path="/book/rent/:bookId"
            exact
            component={RentBook}
          />

          <PrivateRoute
            isLogged={this.props.isAuth}
            path="/book/read/:bookId"
            exact
            component={ReadBook}
          />

          <PrivateRoute
            isLogged={this.props.isAuth}
            path="/myrentedbooks"
            exact
            component={MyRentedBooks}
          />

          <PrivateRoute
            isLogged={this.props.isAuth}
            path="/payment/history"
            exact
            component={PaymentHistory}
          />
          <PrivateRoute
            isLogged={this.props.isAuth}
            path="/payment/details/:paymentUniqueId"
            exact
            component={PaymentDetails}
          />

          <PrivateRoute
            isLogged={this.props.isAuthor}
            path="/book/publish/rules"
            exact
            component={PrePublishRules}
          />
          <PrivateRoute
            isLogged={this.props.isAuthor}
            path="/book/publish"
            exact
            component={PublishBook}
          />
          <PrivateRoute
            isLogged={this.props.isAuthor}
            path="/mymessage"
            exact
            component={AuthorMessage}
          />
          <PrivateRoute
            isLogged={this.props.isAuthor}
            path="/mybooks/author/book/edit/:bookId"
            exact
            component={EditAuthorBooks}
          />

          <PrivateRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            path="/profile"
            exact
            component={Profile}
          />
          <PrivateRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            path="/profile/edit"
            exact
            component={EditProfile}
          />
          <PrivateRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            path="/mybooks/:type"
            exact
            component={MyBooks}
          />
          <PrivateRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            path="/mybooks/edit/:id"
            exact
            component={EditBook}
          />
          <PrivateRoute
            isLogged={this.props.isAuth || this.props.isAuthor}
            path="/confirmationPage"
            exact
            component={EmailConfirmation}
          />
          <PrivateRoute
            isLogged={this.props.isAuth}
            path="/email/verify/:successToken"
            exact
            component={SuccessMessage}
          />
          <PrivateRoute
            isLogged={this.props.isAuthor}
            path="/email/verify/author/:successToken"
            exact
            component={SuccessMessage}
          />

          <Route path="*" exact component={PageNotFound} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    isAuthor: state.AuthorReducer.isAuthor,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

export default connect(mapStateToProps, null)(App);
